var _defs, _path, _line, _path2, _line2, _path3, _line3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneActionsWait1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone-actions-wait-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.562,9.786l1.082,1.083a3,3,0,0,0,4.243,0L8.478,9.278a1.5,1.5,0,0,0,0-2.122L5.384,4.062a1.5,1.5,0,0,0-2.263.148c-3.241,4.4-1.279,9.039,2.7,13.023s8.621,5.946,13.023,2.7A1.5,1.5,0,0,0,19,17.675l-3.1-3.094a1.5,1.5,0,0,0-2.121,0L12.19,16.172a3,3,0,0,0,0,4.243l1.094,1.094"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.881,
    y1: 3.185,
    x2: 13.881,
    y2: 3.185
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.881,3.185a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 17.631,
    y1: 3.185,
    x2: 17.631,
    y2: 3.185
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.631,3.185a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 21.381,
    y1: 3.185,
    x2: 21.381,
    y2: 3.185
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.381,3.185a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneActionsWait1);
export default __webpack_public_path__ + "static/media/phone-actions-wait-1.0213a831.svg";
export { ForwardRef as ReactComponent };